import { render, staticRenderFns } from "./EduLabel.vue?vue&type=template&id=ebb72e0a&scoped=true"
import script from "./EduLabel.vue?vue&type=script&lang=js"
export * from "./EduLabel.vue?vue&type=script&lang=js"
import style0 from "./EduLabel.vue?vue&type=style&index=0&id=ebb72e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb72e0a",
  null
  
)

export default component.exports